import {
  AutoGraphRounded,
  SsidChartRounded,
  StackedLineChartRounded,
  WaterfallChartRounded,
} from "@mui/icons-material";
import { Grid, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatCurrency } from "../../hooks/Currency";

const PeriodicalSalesReports = (props) => {
  const { t } = useTranslation();
  const _store = useSelector((state) => state.pos.defStore);

  const { yearlySells, montlySells, weeklySells, dailySells } = props;

  return (
    <Paper className="br-8 shadow-xs">
      <Grid container>
        <Grid
          item
          xs={12}
          md={3}
          className="d-flex a-center p-40"
          sx={{
            borderRight: { md: "1px solid var(--grayLight-color)" },
            borderBottom: {
              xs: "1px solid var(--grayLight-color)",
              md: "none",
            },
          }}
        >
          <Box className="mr-30">
            <Typography variant="h5" className="fs-16 fw-5 gray-color mb-20">
              {t("yearlySales")}
            </Typography>
            <Typography variant="h5" className="fw-5 fs-22">
              {formatCurrency(yearlySells, _store)}
            </Typography>
          </Box>
          <Box>
            <SsidChartRounded className="fs-60 primary-color" />
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
          className="d-flex a-center p-40"
          sx={{
            borderRight: { md: "1px solid var(--grayLight-color)" },
            borderBottom: {
              xs: "1px solid var(--grayLight-color)",
              md: "none",
            },
          }}
        >
          <Box className="mr-30">
            <Typography variant="h5" className="fs-16 fw-5 gray-color mb-20">
              {t("monthlySales")}
            </Typography>
            <Typography variant="h5" className="fw-5 fs-22">
              {formatCurrency(montlySells, _store)}
            </Typography>
          </Box>
          <Box>
            <StackedLineChartRounded className="fs-60 primary-color" />
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
          className="d-flex a-center p-40"
          sx={{
            borderRight: { md: "1px solid var(--grayLight-color)" },
            borderBottom: {
              xs: "1px solid var(--grayLight-color)",
              md: "none",
            },
          }}
        >
          <Box className="mr-30">
            <Typography variant="h5" className="fs-16 fw-5 gray-color mb-20">
              {t("weeklySales")}
            </Typography>
            <Typography variant="h5" className="fw-5 fs-22">
              {formatCurrency(weeklySells, _store)}
            </Typography>
          </Box>
          <Box>
            <WaterfallChartRounded className="fs-60 primary-color" />
          </Box>
        </Grid>
        <Grid item xs={12} md={3} className="d-flex a-center p-40">
          <Box className="mr-30">
            <Typography variant="h5" className="fs-16 fw-5 gray-color mb-20">
              {t("dailySales")}
            </Typography>
            <Typography variant="h5" className="fw-5 fs-22">
              {formatCurrency(dailySells, _store)}
            </Typography>
          </Box>
          <Box>
            <AutoGraphRounded className="fs-60 primary-color" />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PeriodicalSalesReports;
